import { TestExecutionField } from '@elementary/common-ui/services/gql/types';

export const USER_FIELDS: TestExecutionField[] = [
  'TEST_OWNER',
  'ASSET_OWNER',
  'ASSET_SUBSCRIBER',
];

export const COLUMN_TO_FIELD_MAP: Record<string, TestExecutionField> = {
  latestRunStatus: 'STATUS',
  testName: 'TEST_NAME',
  testSubType: 'SUB_TYPE',
  sourceType: 'SOURCE_TYPE',
  tableName: 'ASSET_TABLE_NAME',
  columnName: 'COLUMN_NAME',
  latestRunTime: 'EXECUTION_TIME',
  failedRows: 'FAILED_ROWS',
  testTags: 'TEST_TAG',
  testOwners: 'TEST_OWNER',
  description: 'TEST_DESCRIPTION',
  qualityDimension: 'QUALITY_DIMENSION',
  assetTags: 'ASSET_TAG',
  assetOwners: 'ASSET_OWNER',
  assetSubscribers: 'ASSET_SUBSCRIBER',
  assetName: 'ASSET_NAME',
  assetPath: 'ASSET_PATH',
  criticalAsset: 'ASSET_IS_CRITICAL',
  assetMaterialization: 'ASSET_BUILD_STRATEGY',
  assetLastDataModificationTime: 'ASSET_LAST_DATA_MODIFICATION_TIME',
  databaseName: 'ASSET_DATABASE_NAME',
  schemaName: 'ASSET_SCHEMA_NAME',
  testCategory: 'TEST_CATEGORY',
};

export const FIELD_TO_COLUMN_MAP: Partial<Record<TestExecutionField, string>> =
  Object.fromEntries(
    Object.entries(COLUMN_TO_FIELD_MAP).map(([column, field]) => [
      field,
      column,
    ]),
  );
